/* eslint-disable */

import React, { Component } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
export default class DropdownBase extends Component {
  constructor(props) {
    super(props);
    this.toggle = () => this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
    this.items = () => {
      const content = [];
      this.props.items.forEach((i, idx) => {
        if (i.submenu !== true) {
          content.push( /*#__PURE__*/React.createElement(DropdownItem, {
            key: "dd_".concat(idx + 1),
            disabled: i.link === 'disabled',
            href: i.link === 'disabled' ? '' : i.link
          }, i.label));
        } else {
          content.push( /*#__PURE__*/React.createElement("ul", {
            key: "ul_".concat(idx + 1),
            style: {
              listStyleType: 'none',
              padding: 0
            }
          }, i.menu));
        }
      });
      return content;
    };
    this.dropdown = () => /*#__PURE__*/React.createElement(Dropdown, {
      nav: true,
      isOpen: this.state.isOpen,
      toggle: () => this.toggle(),
      direction: this.props.submenu ? 'left' : 'down'
    }, /*#__PURE__*/React.createElement(DropdownToggle, {
      nav: true,
      caret: true,
      style: this.props.submenu ? {
        color: 'black'
      } : {}
    }, this.props.name), /*#__PURE__*/React.createElement(DropdownMenu, {
      right: true
    }, this.items()));
    this.state = {
      isOpen: false
    };
  }
  render() {
    return this.dropdown();
  }
}